import $ from "jquery";
import { Email, EmailWrapper } from "../interfaces/email.interface";
import { EmailImpl, EmailWrapperImpl } from "../models/email.model";
import { InCoreSwal2, InCoreSwal2Icon } from "../utils/swal.utils";

export async function emails(): Promise<void> {
    const clone = $(".row.copyMe").clone();
    clone.addClass("email").removeClass("copyMe").appendTo(".col-md-12.blockEmail");
}

export async function emailsRemove(): Promise<void> {
    InCoreSwal2(InCoreSwal2Icon.Question, "Confermi la cancellazione di questo elemento?")
        .then(function (this: HTMLElement, result) {
            if (result.isConfirmed) {
                $(this).parent().parent().parent().remove();
            }
        });
}

export function emailsSave(evt: JQuery.SubmitEvent): void {
    evt.preventDefault();

    const emails: Email[] = [];
    $(".email.row").each((_, element) => {
        const row = $(element);
        const email = new EmailImpl(
            row.find(".email.ename").val() as string,
            row.find(".email.efromname").val() as string,
            row.find(".email.efromaddress").val() as string,
            row.find(".email.elocaldomain").val() as string,
            row.find(".email.eserveraddress").val() as string,
            row.find(".email.eserverport").val() as string,
            row.find(".email.eusername").val() as string,
            row.find(".email.euserpassword").val() as string,
            row.find(".email.ecc").val() as string,
            row.find(".email.eccn").val() as string
        );
        emails.push(email);
    });

    const emailWrapper = new EmailWrapperImpl(emails);

    $.ajax({
        type: "POST",
        url: "/Admin/Emails",
        data: emailWrapper,
        success: () => {
            InCoreSwal2(InCoreSwal2Icon.Success, "Provider Email salvati!").then(() => location.reload());
        },
        error: (result) => {
            InCoreSwal2(InCoreSwal2Icon.Error, result.responseText);
        }
    });
}